import React from "react";
import "./productivity-report.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Countries from "./../../../data/countries";
import {DateRangePicker} from "./../../components";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
let ProductivityReport = () => {
  let TableData = [
    {
      date: "JAN 4, 2022",
      teacherName: "Willow Anderson",
      subject: "Maths, Science, librarie, history",
      class: "1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      totalHours: "30 hours",
      salary: "Salary paid",
    },
    {
      date: "JAN 4, 2022",
      teacherName: "Willow Anderson",
      subject: "Maths, Science, librarie, history",
      class: "1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      totalHours: "30 hours",
      salary: "Salary paid",
    },
    {
      date: "JAN 4, 2022",
      teacherName: "Willow Anderson",
      subject: "Maths, Science, librarie, history",
      class: "1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      totalHours: "30 hours",
      salary: "Salary paid",
    },
    {
      date: "JAN 4, 2022",
      teacherName: "Willow Anderson",
      subject: "Maths, Science, librarie, history",
      class: "1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      totalHours: "30 hours",
      salary: "Salary paid",
    },
    {
      date: "JAN 4, 2022",
      teacherName: "Willow Anderson",
      subject: "Maths, Science, librarie, history",
      class: "1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      totalHours: "30 hours",
      salary: "Salary paid",
    },
    {
      date: "JAN 4, 2022",
      teacherName: "Willow Anderson",
      subject: "Maths, Science, librarie, history",
      class: "1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      totalHours: "30 hours",
      salary: "Salary paid",
    },

    {
      date: "JAN 4, 2022",
      teacherName: "Willow Anderson",
      subject: "Maths, Science, librarie, history",
      class: "1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      totalHours: "30 hours",
      salary: "Salary paid",
    },
    {
      date: "JAN 4, 2022",
      teacherName: "Willow Anderson",
      subject: "Maths, Science, librarie, history",
      class: "1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      totalHours: "30 hours",
      salary: "Salary paid",
    },

    {
      date: "JAN 4, 2022",
      teacherName: "Willow Anderson",
      subject: "Maths, Science, librarie, history",
      class: "1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      totalHours: "30 hours",
      salary: "Salary paid",
    },

    {
      date: "JAN 4, 2022",
      teacherName: "Willow Anderson",
      subject: "Maths, Science, librarie, history",
      class: "1A, 1B, 1C, 2A, 2B, 2C, 3A, 3B, 3C",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      totalHours: "30 hours",
      salary: "Salary paid",
    },
  ];
  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={8} lg={8} md={8} sm={12} xs={12}></Grid>
          <Grid item xl={2} lg={2} md={2} sm={6} xs={6}>
            <Button className="header-button" variant="text">
              <p className="page-header-button-text">Download PDF</p>
            </Button>
          </Grid>
          <Grid item xl={2} lg={2} md={2} sm={6} xs={6}>
            <select className="productivity-report-filter-dropdown">
              <option value="Monthly">Monthly</option>
              <option value="Weekely">Weekely</option>
              <option value="Yearly">Yearly</option>
            </select>
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={7} xs={12}>
            <div>
              <p className="header-input-heading">Teachers Name</p>
              <input
                type="text"
                className="header-input"
                placeholder="Teachers Name"
              />
            </div>
          </Grid>
          <Grid item xl={2} lg={2} md={2} sm={5} xs={12}>
            <div>
              <p className="header-input-heading">Subject Name</p>
              <input
                type="text"
                className="header-input"
                placeholder="Subject Name"
              />
            </div>
          </Grid>
          <Grid item xl={2} lg={2} md={2} sm={5} xs={12}>
            <div>
              <p className="header-input-heading">Country</p>
              <select className="header-dropdown">
                <option value="">Select</option>
                <option value="all">All</option>
                {Countries.map((countriesValue, countriesIndex) => {
                  return (
                    <option key={countriesIndex} value={countriesValue.name}>
                      {countriesValue.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={5} xs={12}>
            <DateRangePicker />
          </Grid>
          <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
            <Button className="header-apply-button" variant="text">
              <p className="header-apply-button-text">Apply</p>
            </Button>
          </Grid>
        </Grid>
      </Box>
      <br />
      <div className="table-container">
        <div className="table-data-container">
          <table>
            <thead>
            <tr>
              <th className="productivity-report-table-date-heading">Date</th>
              <th className="productivity-report-table-teacher-name-heading">
                Teachers Name
              </th>
              <th className="productivity-report-table-subject-name-heading">
                Subject Name
              </th>
              <th className="productivity-report-table-class-or-division-name-heading">
                Class or division name
              </th>
              <th className="productivity-report-table-country-heading">
                country
              </th>
              <th className="productivity-report-table-state-heading">State</th>
              <th className="productivity-report-table-city-heading">City</th>
              <th className="productivity-report-table-total-hour-heading">
                Total hour
              </th>
              <th className="productivity-report-table-salary-heading">
                Salary paid
              </th>
            </tr>
            </thead>
            {TableData.map((tableValue, tableIndex) => {
              return (
                <tr key={tableIndex}>
                  <td className="table-date-data">{tableValue.date}</td>
                  <td className="table-data">{tableValue.teacherName}</td>
                  <td className="table-data">{tableValue.subject}</td>
                  <td className="table-data">{tableValue.class}</td>
                  <td className="table-data">{tableValue.country}</td>
                  <td className="table-data">{tableValue.state}</td>
                  <td className="table-data">{tableValue.city}</td>
                  <td className="table-data">{tableValue.totalHours}</td>
                  <td className="table-data">{tableValue.salary}</td>
                </tr>
              );
            })}
          </table>
        </div>
        <div className="table-pagination-main">
          <Stack spacing={2}>
            <Pagination count={10} variant="outlined" shape="rounded" />
          </Stack>
        </div>
      </div>
    </div>
  );
};
export default ProductivityReport;
